import { Divider } from '@material-ui/core';
import type { PricingList as PricingI } from 'api/types/pricing.types';
import { isPerBagService } from 'api/types/pricing.types';
// assets
import { HomeCareItems, WashFoldItems } from 'assets/icons/';
import { useBagServices } from 'hooks/useBagServices';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  type: PricingI.ServiceTypes;
}
const StyledTile = styled.h3`
  color: ${({ theme }) => theme.components.pricingSheet.itemDescription.textColor};
`;

const PricingList: React.FC<Props> = ({ type }) => {
  const { t } = useTranslation();
  const { services } = useBagServices();

  const [, details] = useMemo(() => services.find(([service]) => service === type) ?? [undefined, undefined], [services, type]);

  if (!details) {
    return null;
  }

  const renderMoreSheet = () => {
    if (isPerBagService(details)) {
      switch (type) {
        case 'WASH_FOLD': {
          return (
            <div className="d-flex flex-column">
              <StyledTile className="pl-7 mb-6">{t('pricingPage.itemsPerfect', 'Items perfect for')}</StyledTile>
              <WashFoldItems className="align-self-center" />
            </div>
          );
        }
        case 'HOME_CARE': {
          return (
            <div className="d-flex flex-column">
              <StyledTile className="pl-7 mb-6">{t('pricingPage.itemsSuitableHc', 'Items suitable for HomeCare')}</StyledTile>
              <HomeCareItems className="align-self-center" />
            </div>
          );
        }
        default:
          return null;
      }
    }
    return null; // Add this line to return null if the condition is not met
  };

  return (
    <div>
      <Divider className="mb-6" />
      {renderMoreSheet()}
    </div>
  );
};

PricingList.displayName = 'PricingList';

export default PricingList;
